module.exports = __webpack_public_path__ + "img/kHdr.36f44c71.svg";